import { useTranslation } from "react-i18next";
import { Pagination, SearchInput } from "ui";

import { MissingItemsTable } from "../../components";
import { useMissingItemsList } from "../../hooks";

import styles from "./MissingItems.module.scss";

const MissingItems = () => {
  const { t } = useTranslation();

  const {
    missingItemsList,
    isLoading,
    page,
    searchValue,
    totalItems,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useMissingItemsList();

  return (
    <div className={styles.missingItems}>
      <div className={styles.missingItems_headerControls}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={`${t("Search")}...`}
        />
      </div>

      <div className={styles.missingItems_tableContainer}>
        <MissingItemsTable
          missingItems={missingItemsList ?? []}
          sorting={sorting}
          setSorting={setSorting}
          isLoading={isLoading}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />
    </div>
  );
};

export default MissingItems;
